export const ORDER_NOTES_WIDTH = '410px';
export enum OrderNotesStatus {
  SUBMIT_DISABLED = 'SUBMIT_DISABLED',
  SUBMIT_ENABLED = 'SUBMIT_ENABLED',
  LOADING = 'LOADING',
}
